<template>
  <div class="setting">
    <Menu
      :active-name="$t('message.setting.global')"
      :open-names="['1', '2']"
      @on-select="getAppVariable"
      ref="settingMenu"
      class="setting-menu">
      <MenuItem :name="$t('message.setting.global')"><Icon type="ios-paper" />{{ $t('message.setting.globalSetting') }}</MenuItem>
      <Submenu
        :name="menu.name"
        v-for="(menu, index) in menuList"
        :key="index">
        <template slot="title">
          <Icon :type="menu.icon" />
          {{ menu.title }}
        </template>
        <MenuItem
          v-for="(item, index2) in menu.children"
          :name="item.name"
          :key="index2"
        >{{ item.title }}</MenuItem>
      </Submenu>
    </Menu>
    <div
      v-if="fullTree && fullTree.length"
      class="setting-content">
      <div class="setting-content-header">
        <Button
          @click="toggleAdvance">{{ isAdvancedShow ? $t('message.setting.hide') : $t('message.setting.show') }}{{ $t('message.setting.advancedSetting') }}</Button>
        <Button
          :loading="loading"
          type="primary"
          class="setting-content-btn"
          @click="save">{{ $t('message.constants.save') }}</Button>
      </div>
      <div
        class="setting-content-variable"
        :style="{'height': height - 40 + 'px'}">
        <variable
          v-for="(item, index) in fullTree"
          ref="variable"
          :key="index"
          :variable="item"
          @add-item="handleAdd"
          @remove-item="handleDelete"
          :un-valid-msg="unValidMsg"
          :is-advanced-show="isAdvancedShow"/>
      </div>
    </div>
    <!-- 调用dlink的几个管理界面 -->
    <div v-else 
        class="setting-content">
      <iframe 
        id="iframeForRegistration"
        :src="`${dinky_setting_url}`"
        frameborder="0"
        width="100%"
        height="100%"></iframe>
    </div>
  </div>
</template>
<script>
import { orderBy } from 'lodash';
import api from '@dss/js/service/api';
import variable from '@dss/js/component/variable';
import {DINKY_WEB} from '@/api/index';
export default {
  name: 'Setting',
  components: {
    variable,
  },
  data() {
    return {
      DINKY_WEB,
      dinky_setting_url:DINKY_WEB + 'registration/cluster',
      menuList: [{
        name: '2',
        title: this.$t('message.setting.dataDev'),
        icon: 'ios-people',
        children: [{
          name: 'IDE-spark',
          title: 'Spark',
        }, {
          name: 'IDE-hive',
          title: 'Hive',
        },
        {
          name: 'IDE-python',
          title: 'Python',
        }, {
          name: 'IDE-pipeline',
          title: 'PipeLine',
        },
        {
          name: 'IDE-jdbc',
          title: 'Jdbc',
        }],
      }, {
        name: '3',
        title: 'Visualis',
        icon: 'md-analytics',
        children: [{
          name: 'visualis-spark',
          title: 'Spark',
        }],
      },
      {
        name: '4',
        title: '工作流',
        icon: 'md-analytics',
        children: [{
          name: 'nodeexecution-spark',
          title: 'Spark',
        }, {
          name: 'nodeexecution-hive',
          title: 'Hive',
        },
        {
          name: 'nodeexecution-python',
          title: 'Python',
        },
        {
          name: 'nodeexecution-jdbc',
          title: 'Jdbc',
        }],
      },
      {
        name: '5',
        title: '实时计算设置',
        icon: 'ios-analytics',
        children: [
        {
          name: 'flinksql-case',
          title: '集群实例',
        }, 
        {
          name: 'flinksql-setting',
          title: '集群配置',
        },
        {
          name: 'jar-management',
          title: 'Jar 管理',
        },
      /*   {
          name: 'db-management',
          title: '数据源管理',
        }, */
        {
          name: 'doc-management',
          title: '文档',
        },
        {
          name: 'flink-setting',
          title: 'Flink 设置',
        }
        ],
      }

      ],
      activeMenu: '',
      fullTree: [],
      loading: false,
      unValidMsg: {},
      isAdvancedShow: false,
      height: 0,
    };
  },
  mounted() {
    
    this.height = this.$route.query.height;
    this.$nextTick(() => {
      this.$refs.settingMenu.updateActiveName();
      this.getAppVariable('全局');
    });
  },
  methods: {
    getAppVariable(type) {
      
      this.activeMenu = type;
      const IDE = 'IDE';
      const VSBI = 'visualis';
      const NODEECECUTION = 'nodeexecution';
      let appName = '通用设置';
      let creator = '通用设置';
      let filterMenuName = ['flinksql-case','flinksql-setting','jar-management','db-management','doc-management','flink-setting'];
      this.fullTree = [];
      this.dinky_setting_url = "";
      if (type.match(IDE)) {
        creator = IDE;
        appName = type.slice(IDE.length + 1, type.length);
      } else if (type.match(VSBI)) {
        creator = VSBI;
        appName = type.slice(VSBI.length + 1, type.length);
      } else if (type.match(NODEECECUTION)) {
        creator = NODEECECUTION;
        appName = type.slice(NODEECECUTION.length + 1, type.length);
      }else if(filterMenuName.indexOf(type)>-1){
        let menuNameIndex = filterMenuName.indexOf(type);
        // console.log(DINKY_WEB);
        switch(menuNameIndex){
          case 0:this.dinky_setting_url = DINKY_WEB + 'registration/cluster';break;
          case 1:this.dinky_setting_url = DINKY_WEB + 'registration/clusterConfiguration';break;
          case 2:this.dinky_setting_url = DINKY_WEB + 'registration/jar';break;
          case 3:this.dinky_setting_url = DINKY_WEB + 'registration/database';break;
          case 4:this.dinky_setting_url = DINKY_WEB + 'registration/document';break;
          case 5:this.dinky_setting_url = DINKY_WEB + 'registration/settings';break;
        }
        return;
      }
      api.fetch('/configuration/getFullTreesByAppName', {
        appName,
        creator,
      }, 'get').then((rst) => {
        this.loading = false;
        this.fullTree = rst.fullTree;
        this.fullTree.forEach((item) => {
          item.settings = orderBy(item.settings, ['level'], ['asc']);
          if (item.settings.length) {
            item.settings.forEach((set) => {
              if (set.validateType === 'OFT') {
                set.validateRangeList = this.formatValidateRange(set.validateRange, set.key);
              }
            });
          }
        });
      }).catch(() => {
        this.loading = false;
      });
    },
    formatValidateRange(value, type) {
      let formatValue = [];
      let tmpList = [];
      try {
        tmpList = JSON.parse(value);
      } catch (e) {
        tmpList = value.slice(1, value.length - 1).split(',');
      }
      tmpList.forEach((item) => {
        formatValue.push({
          name: item === 'BLANK' && type === 'pipeline.out.null.type' ? '空字符串' : item,
          value: item,
        });
      });
      return formatValue;
    },
    handleAdd(item, parent, cb) {
      setTimeout(() => {
        cb(true);
      }, 200);
    },
    handleDelete(item, parent, cb) {
      setTimeout(() => {
        cb(true);
      }, 200);
    },
    save() {
      this.loading = true;
      this.checkValid();
      api.fetch('/configuration/saveFullTree', {
        fullTree: this.fullTree,
      }).then(() => {
        this.getAppVariable(this.activeMenu);
        this.unValidMsg = {};
        this.$Message.success(this.$t('message.constants.save'));
      }).catch((err) => {
        this.loading = false;
        if (err.message) {
          let key = '';
          let msg = '';
          this.fullTree.forEach((item) => {
            if (item.settings) {
              item.settings.forEach((s) => {
                if (s.validateType === 'OFT' && s.hasOwnProperty('validateRangeList')) {
                  delete s.validateRangeList;
                }
                if (err.message.indexOf(s.key) > -1) {
                  msg = s.description;
                  key = s.key;
                }
              });
            }
          });
          this.unValidMsg = { key, msg };
        }
      });
    },
    checkValid() {
      if (this.activeMenu === '全局') {
        this.fullTree.forEach((item) => {
          item.settings.forEach((set) => {
            if (set.key === 'bdp.dwc.yarnqueue.memory.max' || set.key === 'bdp.dwc.client.memory.max') {
              const unit = set.defaultValue[set.defaultValue.length - 1];
              if (set.value) {
                if (set.value[set.value.length - 1].toLowerCase() !== unit.toLowerCase()) {
                  set.value += unit;
                }
              }
            }
          });
        });
      }
    },
    toggleAdvance() {
      this.isAdvancedShow = !this.isAdvancedShow;
    },
  },
};
</script>
<style src="./index.scss" lang="scss"></style>
